module.exports = __webpack_public_path__ + "img/U_illustration.da9d30df.gif";